import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import ArticleTemplate from '@/pages/article/components/ArticleTemplate';
import { guideArticle } from '@/mocks/articleData';

export default function GuideArticle() {
  return (
    <>
      <Navbar />
      <ArticleTemplate article={guideArticle} />
      <Footer />
    </>
  );
}